import { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { identifyAuthenticatedUser } from '../../lib/analytics/posthog';

const PostHogUserSync = () => {
  const { user, isLoading } = useAuth();
  const { language } = useLanguage();

  useEffect(() => {
    if (isLoading || !user?.id?.trim()) {
      return;
    }
    identifyAuthenticatedUser(user.id, { app_language: language });
  }, [isLoading, user?.id, language]);

  return null;
};

export default PostHogUserSync;
